import { AbstractButtonActionsService } from './AbstractButtonActionsService';
import { IButtonActionsService } from './buttonActionsServiceTypes';

export class ButtonActionsServiceStub
	extends AbstractButtonActionsService
	implements IButtonActionsService
{
	constructor() {
		super();

		setTimeout(() => this.showAction('hud', 'Начать диалог', 'Space'), 3000);
	}

	public showAction(id: string, text: string, button: string): void {
		super.showAction(id, text, button);

		console.log('showAction', { id, text, button });
	}

	public hideAction(id: string): void {
		super.hideAction(id);

		console.log('hideAction', { id });
	}
}
